import { Link } from 'react-router-dom'

export function LoginTerms() {
  return (
    <div className="mt-6 text-center">
      <p className="text-xs text-gray-500 lg:text-sm">
        By signing in, you agree to our{' '}
        <Link
          to="/terms"
          className="text-blue-500 underline hover:text-blue-600"
        >
          Terms of Service
        </Link>{' '}
        and{' '}
        <Link
          to="/privacy"
          className="text-blue-500 underline hover:text-blue-600"
        >
          Privacy Policy
        </Link>
      </p>
    </div>
  )
}
